import React from 'react';
import styled from 'styled-components';
import {
  UIText,
  LinkText,
  LinkTextStyles,
  CombinedLinkTextProps,
} from '../typography';
import { DataType } from './types';

type CellProps = {
  content: string | number;
  href?: string;
  onClick?: () => void;
  isBold?: boolean;
  type?: DataType;
};

type TextProps = {
  isBold?: boolean;
};

const Link = styled(LinkText)<TextProps>`
  ${({ isBold }) => isBold && `font-weight: 700;`}
`;

const ActionLink = styled.p<TextProps & CombinedLinkTextProps>`
  ${LinkTextStyles}
  ${({ isBold }) => isBold && `font-weight: 700;`}
`;

const Text = styled(UIText)<TextProps>`
  ${({ isBold }) => isBold && `font-weight: 700;`}
`;

export const Cell: React.FC<CellProps> = ({
  content,
  href,
  onClick,
  isBold,
  type,
  ...props
}) => {
  return href ? (
    <Link href={href} download isBold={isBold} styleType="ui" {...props}>
      {content}
    </Link>
  ) : onClick ? (
    <ActionLink
      size="md"
      isUnderlined={false}
      context="secondary"
      onClick={onClick}
      isBold={isBold}
      styleType="ui"
      {...props}
    >
      {content}
    </ActionLink>
  ) : (
    <Text isBold={isBold} {...props}>
      {type === 'currency'
        ? `$${Intl.NumberFormat('en-AU').format(Number(content))}`
        : content}
    </Text>
  );
};
